import { useState } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";

const DisplayAdUnitSetting = ({ displayAdPayload }) => {
    const { register, handleSubmit } = useForm();

    const onSubmit = (formData) => {
        displayAdPayload({
            adUnitPayload: formData
        });
    };


    return (
        <div style={{ background: "#f5f5f5", padding: "25px" }}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <h5 style={{ color: "#007bff" }}>Display Ad Unit Setting</h5>
                <Form.Group className="mt-4">
                    <Form.Label>Ad Unit </Form.Label>
                    <input tyep="text" {...register("name")} />
                </Form.Group>
                <input className="mt-4 btn btn-primary" type="submit" value="Rename" />
            </form>
        </div>
    )
}

export default DisplayAdUnitSetting;